import {Component, Input, OnInit} from "@angular/core";
import {FormArray, FormControl, FormGroup} from "@angular/forms";
import {MatTabChangeEvent} from "@angular/material/tabs";
import {ICompanionForm} from "../../../../../../shared/interfaces/forms/exercises/ICompanionForm";
import {ECompanionSimultaneousType} from "../../../../../../shared/enums/ECompanionSimultaneousType";
import {ECompanionAgilityType} from "../../../../../../shared/enums/ECompanionAgilityType";
import {ValidationHelperService} from "../../../../../../core/helpers/validation-helper.service";
import {
  COMPANION_DELAY_OPTIONS,
  COMPANION_PROMPT_OPTIONS,
} from "../../companion-timer-options";
import {COMPANION_COLOR_OPTIONS} from "../../companion-color-options";

@Component({
  selector: "app-companion-simultaneous-form",
  templateUrl: "./companion-simultaneous-form.component.html",
  styleUrls: ["./companion-simultaneous-form.component.scss"],
})
export class CompanionSimultaneousFormComponent implements OnInit {
  @Input() _formGroup: FormGroup<ICompanionForm>;
  readonly delayOptions = COMPANION_DELAY_OPTIONS;
  readonly promptOptions = COMPANION_PROMPT_OPTIONS;
  readonly colorOptions = COMPANION_COLOR_OPTIONS;

  ngOnInit(): void {
    this.normalizeCompanionType();
  }

  get react(): boolean[] {
    return this.reactTo.value;
  }

  get dontReact(): boolean[] {
    return this.dontReactTo.value;
  }

  get reactTo(): FormArray<FormControl<boolean>> {
    return this._formGroup.controls.reactTo;
  }

  get dontReactTo(): FormArray<FormControl<boolean>> {
    return this._formGroup.controls.dontReactTo;
  }

  get simultaneousType(): FormControl<ECompanionSimultaneousType> {
    return this._formGroup.controls.simultaneousType;
  }

  get agilityType(): FormControl<ECompanionAgilityType> {
    return this._formGroup.controls.agilityType;
  }

  get companionTypeTabIndex(): number {
    return this.agilityType.value === ECompanionAgilityType.Number ? 1 : 0;
  }

  get selectedSensors(): FormArray<FormControl<number>> {
    return this._formGroup.controls.sequenceSensors;
  }

  get showTimerControls(): boolean {
    return (
      this.simultaneousType.value === ECompanionSimultaneousType.Sequence
    );
  }

  get showSensorSelection(): boolean {
    return (
      this.simultaneousType.value === ECompanionSimultaneousType.Sequence
    );
  }

  setReact(color: number, dontReact: boolean): void {
    const selected = dontReact ? this.dontReactTo : this.reactTo;
    const opposite = dontReact ? this.reactTo : this.dontReactTo;
    selected.controls[color].setValue(!selected.controls[color].value);
    if (selected.controls[color].value && opposite.controls[color].value) {
      opposite.controls[color].setValue(false);
    }
    this._formGroup.updateValueAndValidity();
  }

  addSensor(sensor: number): void {
    if (this.selectedSensors.length >= 200) return;
    this.selectedSensors.push(new FormControl(sensor));
    this._formGroup.updateValueAndValidity();
  }

  removeSensor(index: number): void {
    this.selectedSensors.removeAt(index);
    this._formGroup.updateValueAndValidity();
  }

  resetSensors(): void {
    this.selectedSensors.clear();
    this._formGroup.updateValueAndValidity();
  }

  onSimultaneousTabChange(event: MatTabChangeEvent): void {
    this.simultaneousType.setValue(event.index as ECompanionSimultaneousType);
    this._formGroup.updateValueAndValidity();
  }

  onVisualTypeChange(event: MatTabChangeEvent): void {
    const visualTypes = [
      ECompanionAgilityType.Color,
      ECompanionAgilityType.Number,
    ];
    const selected = visualTypes[event.index];
    if (selected !== undefined) {
      this.agilityType.setValue(selected);
      this._formGroup.updateValueAndValidity();
    }
  }

  private normalizeCompanionType(): void {
    if (
      this.agilityType.value !== ECompanionAgilityType.Color &&
      this.agilityType.value !== ECompanionAgilityType.Number
    ) {
      this.agilityType.setValue(ECompanionAgilityType.Color);
      this._formGroup.updateValueAndValidity();
    }
  }

  protected readonly ECompanionSimultaneousType = ECompanionSimultaneousType;
  protected readonly ECompanionAgilityType = ECompanionAgilityType;
  protected readonly ValidationHelperService = ValidationHelperService;
}
